import { SelectHelperMenuItem } from 'bold-ui'

export interface MaisItensSelectMenuItemProps {
  selectMaxItems: number
}

export function MaisItensSelectMenuItem(props: MaisItensSelectMenuItemProps) {
  const { selectMaxItems } = props
  return (
    <SelectHelperMenuItem
      onClick={(ev) => {
        ev.stopPropagation()
        ev.preventDefault()
      }}
    >
      Mostrando somente os primeiros {selectMaxItems} resultados. Para ver outros resultados, refine sua busca.
    </SelectHelperMenuItem>
  )
}
